import React from 'react'
import PropTypes from 'prop-types'
import { FaFileWord, FaFilePdf, FaFileExcel, FaFileImage, FaFilePowerpoint, FaFile } from 'react-icons/fa'
import { downloadDocument } from '../../service/documentsService'
import { openFileInNewTab } from '../../util/documentManager'

export default class FileLink extends React.Component {

    fileType = () => {
        //        const fileName = this.fileName() // Get file name from url 
        const values = this.props.file.Name.split('.')
        const type = values[values.length - 1]
        return type
    }

    fileName = () => {
        const values = this.props.file.documentURL.Url.split('/')
        const fileName = values[values.length - 1]
        return fileName
    }

    fileIcon = () => {
        switch (this.fileType()) {
            case 'docx':
            case 'doc':
            case 'odt':
                return <FaFileWord className="icon" style={{ color: "#295294" }} />
            case 'xls':
            case 'xlsx':
            case 'csv':
                return <FaFileExcel className="icon" style={{ color: "#1E6D42" }} />
            case 'pdf':
                return <FaFilePdf className="icon" style={{ color: "#C30809" }} />
            case 'jpg':
            case 'jpeg':
            case 'png':
            case 'gif':
                return <FaFileImage className="icon" style={{ color: "#23707A" }} />
            case 'pwp':
            case 'ppt':
            case 'pptx':
                return <FaFilePowerpoint className="icon" style={{ color: "#CB4424" }} />
            default:
                return <FaFile className="icon" />
        }
    }

    downloadFile = (e) => {
        e.preventDefault()
        e.stopPropagation()
        // Should download here
        downloadDocument(this.props.file.Url)
            .then(({ data }) => {
                openFileInNewTab(data, this.props.file.Name)
            })
            .catch(err => {
                console.log(err)
            })
    }

    render() {
        try {
            return (
                <div className="file-link" onClick={(e) => this.downloadFile(e)} ><div className="file-icon">{this.fileIcon()}</div>{this.props.file.Name}</div>
            )
        } catch (err) {
            return (<React.Fragment />)
        }
    }
}

FileLink.propTypes = {
    file: PropTypes.shape({
        documentURL: PropTypes.shape({
            Description: PropTypes.string,
            Url: PropTypes.string
        }),
        Id: PropTypes.string,
        TimeCreated: PropTypes.string
    })
}